import { css, CSSObject, SerializedStyles } from '@emotion/react'
import { fonts } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const listItemAnimationBase = 10

export const collapsedStyles = (
  warning: boolean,
  emptyList: boolean
): SerializedStyles =>
  css({
    background: colors.n10.base,
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: fonts.sourceCode,
    fontSize: '12px',
    fontWeight: 500,
    cursor: emptyList ? 'not-allowed' : 'pointer',
    '> *': {
      cursor: emptyList ? 'not-allowed' : 'pointer',
    },
    color: colors.n4.base,
    '.kuiper-icon-wrapper': {
      padding: '0 10px',
      color: warning ? '#ff3ca0' : '',
    },
    '> span': {
      width: '100%',
      marginBottom: '2px',
    },
  })

export const titleRowStyles = (emptyList: boolean): SerializedStyles =>
  css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontFamily: fonts.proxima,
    fontSize: '10px',
    height: '16px',
    letterSpacing: '0px',
    color: colors.n5.base,
    margin: '0px 20px 6px',
    cursor: emptyList ? 'not-allowed' : 'pointer',
    '> *': {
      cursor: emptyList ? 'not-allowed' : 'pointer',
    },
  })

export const buttonStyles = css({
  color: colors.n5.base,
  background: 'transparent',
  outline: 'none',
  border: 'none',
  '&:hover': {
    background: colors.n10.base,
    color: 'black',
  },
  height: '16px',
  borderRadius: '3px',
})

export const countStyles = (warning: boolean): SerializedStyles =>
  css({
    background: warning ? '#ff525c' : '#d0dae1',
    color: warning ? colors.white.base : '',
    borderRadius: '20px',
    height: '20px',
    width: '28px',
    fontFamily: fonts.sourceCode,
    fontWeight: 'bold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 10px',
  })

export const listStyles = (): SerializedStyles =>
  css({
    margin: '0',
    padding: '0',
    '> *': {
      opacity: 0,
      animation: `fadeIn ${listItemAnimationBase}ms ease 1`,
      animationFillMode: 'forwards',
    },
    overflowY: 'auto',
  })

export const listChildDelay = (): SerializedStyles => {
  const styles: CSSObject = {}

  for (let i = 1; i <= 20; i += 1) {
    styles[`li:nth-of-type(${i})`] = {
      animationDelay: `${listItemAnimationBase * (i - 1)}ms`,
    }
  }

  return css(styles)
}
